// extracted by extract-css-chunks-webpack-plugin
module.exports = {"list":"list_2K_dq","qq":"qq_3ATg1","tel":"tel_3uW3q","email":"email_Kkidj"};